"use strict";

const { getGlobalMonotonicClockMS } = require("./lib/global-monotonic-clock");
const { Performance } = require("./lib/performance");
const clockIsAccurate = require("./lib/clock-is-accurate");

module.exports = {
  Performance,
  getGlobalMonotonicClockMS,
  clockIsAccurate
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_w3c-hr-time@1.0.2@w3c-hr-time/index.js
// module id = vNjr
// module chunks = 0